<template>
  <v-card>
    <v-card-text>
      <h3>Computer Data Storage</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'bit (bit)',
          val: 1
        },
        {
          text: 'byte (B)',
          val: 0.125
        },
        {
          text: 'kilobit (Kbit)',
          val: 0.0009765625
        },
        {
          text: 'kilobyte (KB)',
          val: 0.0001220703125
        },
        {
          text: 'megabit (Mbit)',
          val: 9.536743164063e-7
        },
        {
          text: 'megabyte (MB)',
          val: 1.192092895508e-7
        },
        {
          text: 'gigabit (Gbit)',
          val: 9.313225746155e-10
        },
        {
          text: 'gigabyte (GB)',
          val: 1.164153218269e-10
        },
        {
          text: 'terabit (Tbit)',
          val: 9.094947017729e-13
        },
        {
          text: 'terabyte (TB)',
          val: 1.136912032962e-13
        },
        {
          text: 'petabit (Pbit)',
          val: 8.881784160621e-16
        },
        {
          text: 'petabyte (PB)',
          val: 2.953157760203e-10
        },
        {
          text: 'floppy disk (3.5", DD)',
          val: 1.71507288469e-7
        },
        {
          text: 'floppy disk (3.5", HD)',
          val: 8.575364417629e-8
        },
        {
          text: 'floppy disk (5.25", DD)',
          val: 3.430145764374e-7
        },
        {
          text: 'floppy disk (5.25", HD)',
          val: 1.02969474881e-7
        },
        {
          text: 'Zip 100',
          val: 1.244624808896e-9
        },
        {
          text: 'Zip 250',
          val: 4.978499258868e-10
        },
        {
          text: 'Jaz 1GB',
          val: 1.164153218269e-10
        },
        {
          text: 'Jaz 2GB',
          val: 5.820766091347e-11
        },
        {
          text: 'CD (74 minute)',
          val: 1.835378818214e-10
        },
        {
          text: 'CD (80 minute)',
          val: 1.697725383565e-10
        },
        {
          text: 'DVD (1 layer)',
          val: 2.476922236383e-11
        },
        {
          text: 'DVD (2 layer)',
          val: 1.369592500851e-11
        },
        {
          text: 'Blu-ray (1 layer)',
          val: 4.656612873077e-12
        },
        {
          text: 'Blu-ray (2 layer)',
          val: 2.328306436539e-12
        },
        {
          text: 'HD-DVD (1 layer)',
          val: 7.761021454353e-12
        },
        {
          text: 'HD-DVD (2 layer)',
          val: 3.880506847054e-12
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// computer.vue?1e74bb70